import React, { Component } from 'react';
import PropTypes from 'prop-types';

class TextExpand extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isExpanded: true,
    };
    if (props.text && props.text.length > props.minChar) {
      this.state.isExpanded = false;
    }
  }
  handleExpand = (e) => {
    e.preventDefault();
    this.setState({ isExpanded: true });
  }
  render() {
    if (!this.state.isExpanded) {
      return (
        <div>
          <button
            className="a-button-blue text_expand_single"
            style={{ width: this.props.width }}
            onClick={this.handleExpand}
            title="View more"
          >
            {this.props.text}
          </button>
        </div>
      );
    }
    return (
      <div className="text_expand" style={{ width: this.props.width }}>
        {this.props.text}
      </div>
    );
  }
}

TextExpand.propTypes = {
  text: PropTypes.string.isRequired,
  minChar: PropTypes.number,
  width: PropTypes.string.isRequired,
};

TextExpand.defaultProps = {
  minChar: 24,
};

export default TextExpand;



// WEBPACK FOOTER //
// ./src/components/TextExpand.jsx